var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _text, _text2, _text3, _text4, _text5, _text6, _text7, _path0, _path1, _path10, _text8, _text9, _text0, _text1, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAerosoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 912.72 804.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#002566}.cls-4{fill:none;stroke:#002566;stroke-miterlimit:10;stroke-width:7px}.cls-11{isolation:isolate}.cls-3{font-family:Helvetica-Bold,Helvetica;font-size:109.22px;font-weight:700}.cls-14{fill:#f3dc99}.cls-11{fill:#fff;opacity:.5}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M547.93 248.37c3.28 8.93 6.26 18.36 8.9 28.21 8.91 33.25 13.98 71.36 13.98 111.87s-4.91 77.41-13.56 110.29c-2.86 10.87-6.13 21.22-9.77 30.99M287.87 378.84c26.29-31.96 63.4-63.61 108.16-90.08 45.94-27.17 92.78-44.66 134.25-51.98",
    className: "cls-4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M283.24 394.64c-36.37-45.27-50.19-90.9-31.94-122.78 31.78-55.51 148.73-48.32 261.22 16.07 89.57 51.27 149.3 123.34 153.89 178.6",
    className: "cls-4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M348.71 264.02c67.86-59.32 170.31-48.85 229.63 19.01s54.08 168.58-13.78 227.9S392.32 565.37 333 497.51s-52.15-174.17 15.7-233.49Z",
    style: {
      fill: "#e6b933"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.56 282.61c64.22-56.14 159.93-47.68 214.56 14.82 54.63 62.49 48.46 156.43-15.76 212.57s-161.79 52.91-216.43-9.58c-54.63-62.49-46.58-161.66 17.63-217.8Z",
    style: {
      fill: "#e0a800"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M447.18 316.2c-11.52 23.96-40.51 33-64.47 21.48s-34.22-39.44-22.7-63.39c11.52-23.96 40.39-34.74 64.34-23.22 23.96 11.52 34.34 41.18 22.83 65.13",
    className: "cls-14"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M372.66 288.01c11.52-23.96 40.39-34.74 64.34-23.22 2.65 1.28 5.14 2.77 7.45 4.46-4.71-7.66-11.54-14.08-20.09-18.19-23.96-11.52-52.83-.74-64.34 23.22-10.16 21.13-3.37 45.34 14.8 58.66-8.03-13.15-9.42-29.83-2.16-44.93",
    style: {
      isolation: "isolate",
      opacity: 0.06,
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.89 365.61c-.75-3.69 1.74-7.19 5.43-7.93 3.69-.75 7.23 1.52 7.98 5.2s-1.58 7.37-5.27 8.12-7.39-1.7-8.14-5.38Z",
    style: {
      fill: "#f9eecc"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M523.75 287.56c-.75-3.69 1.74-7.19 5.43-7.93 3.69-.75 7.23 1.52 7.98 5.2s-1.58 7.37-5.27 8.12-7.39-1.7-8.14-5.38Z",
    className: "cls-11"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M472.07 481.31c5.59-4.88 14.02-4.02 18.9 1.56 4.88 5.59 4.45 13.88-1.14 18.76s-14.18 4.48-19.06-1.11-4.29-14.34 1.29-19.22Z",
    style: {
      fill: "#d4d5b1"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M327.83 367.27c-.75-3.69 1.74-7.19 5.43-7.93 3.69-.75 7.23 1.52 7.98 5.2s-1.58 7.37-5.27 8.12-7.39-1.7-8.14-5.38Z",
    className: "cls-11"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M591.75 406.31c-2.39 23.56-23.94 39.91-47.5 37.52s-40.61-22.67-38.21-46.23c2.39-23.56 23.32-41.33 46.87-38.94 23.56 2.39 41.24 24.09 38.84 47.65m-190.07 31.78c9.4 16.28 3.13 36.82-13.15 46.23s-36.68 4.27-46.09-12.01c-9.4-16.28-4.2-37.44 12.09-46.85 16.28-9.4 37.75-3.65 47.15 12.63",
    className: "cls-14"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M362.85 433.71c11.87-6.86 26.49-5.65 37.19 1.81-10.09-14.29-30.11-18.96-45.5-10.07-16.28 9.4-21.49 30.57-12.09 46.85 2.6 4.5 6.03 8.14 9.99 10.86-.59-.84-1.15-1.7-1.67-2.6-9.4-16.28-4.2-37.44 12.09-46.85Z",
    style: {
      isolation: "isolate",
      opacity: 0.06,
      fill: "#f3dc99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.1 406.56c2.39-23.56 23.32-41.33 46.87-38.94 7.85.8 15.05 3.74 21.07 8.19-7.08-9.34-17.8-15.89-30.14-17.15-23.56-2.39-44.47 15.38-46.87 38.94-1.58 15.59 5.34 29.73 17.04 38.22-5.99-8.07-9.08-18.31-7.97-29.25Z",
    style: {
      fill: "#040000",
      isolation: "isolate",
      opacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.03 470.11c-67.5 0-127.12-33.69-163.19-85.19-1.73 64.53 35.59 125.75 98.62 153.19 82.5 35.92 179.16.99 214.72-82.34 9.78-22.92 13.88-47.07 13-70.8-36.07 51.47-95.68 85.13-163.15 85.13Z",
    style: {
      opacity: 0.1,
      fill: "#040000",
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M290.56 403.38c-2.53-2.91-4.97-5.83-7.31-8.74m249.71 144.48c-41.71-6.68-88.99-23.52-135.51-50.15-43.72-25.03-80.34-55.01-106.9-85.58",
    className: "cls-4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M547.48 529.73c-21.14 56.74-54.7 93.41-92.49 93.41-63.96 0-115.82-105.07-115.82-234.69 0-100.4 31.11-186.07 74.86-219.6m82.37.35c20.68 16.05 38.51 43.76 51.53 79.17",
    className: "cls-4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M624.42 533.42c-23.61 9.64-55.46 11.46-91.46 5.7m-2.68-302.34c59.25-10.46 107.56-.19 126.71 32.19 32.56 55.06-31.48 153.18-143.04 219.16-82.88 49.02-168.67 66.51-220.66 49.69m-48.67-67c1.48-27.74 16.96-60.02 43.25-91.98",
    className: "cls-4"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "rotate(14.54 -2693.164 1185.095)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "rotate(9.34 -4346.743 2113.935)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "rotate(3.47 -12154.418 6541.39)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "rotate(-.8 54058.364 -32239.994)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "rotate(-4.88 9065.826 -5357.84)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "rotate(-10 4539.817 -2856.12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "rotate(-14.73 3151.36 -2086.056)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Y"))), /*#__PURE__*/React.createElement("path", {
    d: "M443.59 183.67h8.96l8.95-8.97h7.42c6.72-.01 13.16-2.69 17.91-7.44l6.01-6.02-6.02-6.01a25.3 25.3 0 0 0-17.92-7.4h-7.42l-8.96-8.94h-8.96l.04 44.79Zm21.26-19.05c1.86 1.85 4.86 1.85 6.72 0s1.85-4.86 0-6.72c-1.86-1.85-4.86-1.85-6.72 0s-1.85 4.86 0 6.72",
    style: {
      fill: "#002566",
      fillRule: "evenodd"
    }
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M437.24 167.29v-12.02l-13.83 3.78v4.48zM247.63 516.41c-4.16-4.94-11.74-5.59-16.87-1.44-.41.35-.63.71-.68 1.28s.11.96.46 1.38l5.2 6.17-4.11 3.47c-.41.35-.65.9-.68 1.28s.11.96.46 1.38c.69.82 1.83.92 2.65.23l4.11-3.47 5.2 6.17c.69.82 1.83.92 2.65.23 5.11-3.95 5.76-11.53 1.62-16.66Zm8.39 2.44 5.76-4.85 2.77 3.29-5.76 4.85c-.41.35-.65.9-.68 1.28s.11.96.46 1.38l3.12 3.7 17.28-14.56-3.12-3.7c-.69-.82-1.83-.92-2.65-.23l-5.76 4.85-2.77-3.29 16.05-13.52c.82-.69.92-1.83.23-2.65l-6.93-8.23c-.69-.82-1.83-.92-2.65-.23l-16.05 13.52-2.77-3.29 5.76-4.85c.82-.69.92-1.83.23-2.65l-3.12-3.7-17.28 14.56 3.12 3.7c.69.82 1.83.92 2.65.23l5.76-4.85 2.77 3.29-5.76 4.85c-.41.35-.65.9-.68 1.28s.11.96.46 1.38l6.93 8.23c.69.82 1.83.92 2.65.23Zm-6.17-39.47c-.69-.82-1.83-.92-2.65-.23l-14.4 12.13c-.41.35-.63.71-.68 1.28s.11.96.46 1.38l3.12 3.7 17.28-14.56-3.12-3.7Zm17.38 55.7c.69.82 1.83.92 2.65.23l14.4-12.13c.82-.69.92-1.83.23-2.65l-3.12-3.7-17.28 14.56 3.12 3.7Zm379.69-50.75c-.78.09-1.32.8-1.21 1.57s.82 1.33 1.6 1.23 1.32-.8 1.21-1.57c-.11-.78-.82-1.33-1.6-1.23m2.08.75.11.84 6.22-.76c.14-.02.25-.1.3-.23s.03-.27-.05-.38l-.28-.37c-.36-.48-.95-.73-1.53-.65l-3.22.39s-.49 1.03-1.56 1.16Zm-3.77 1.31-.12-.84-6.22.76a.39.39 0 0 0-.31.23c-.05.13-.03.27.05.38l.28.37c.36.48.94.73 1.53.66l3.22-.39s.49-1.03 1.56-1.16Zm20.89 15.26c.78-.1 1.32-.8 1.21-1.57-.11-.78-.82-1.33-1.6-1.23s-1.32.8-1.21 1.57c.11.78.82 1.33 1.6 1.23m1.69-2.07.11.84 6.22-.76c.14-.02.25-.1.3-.23s.03-.27-.05-.38l-.28-.37c-.36-.48-.95-.73-1.53-.65l-3.22.39s-.49 1.03-1.56 1.16Zm-3.77 1.32-.12-.84-6.22.76a.39.39 0 0 0-.31.23c-.05.13-.03.27.05.38l.28.37c.36.48.94.73 1.53.66l3.22-.39s.49-1.03 1.56-1.16Zm-31.43 1.99c-.78.1-1.32.8-1.21 1.58.11.77.82 1.33 1.6 1.23.77-.1 1.32-.8 1.21-1.58-.11-.77-.82-1.33-1.6-1.23m2.08.74.11.84 6.22-.76c.14-.02.25-.1.3-.23s.03-.27-.05-.38l-.28-.37c-.36-.48-.95-.73-1.53-.66l-3.22.39s-.49 1.03-1.56 1.16Zm-3.77 1.32-.12-.85-6.22.76a.39.39 0 0 0-.31.23c-.05.13-.03.27.05.38l.28.37c.36.48.94.73 1.53.66l3.22-.39s.49-1.03 1.56-1.16Zm20.51 12.44c-.78.1-1.32.8-1.21 1.58s.82 1.33 1.6 1.23 1.32-.8 1.21-1.58c-.11-.77-.82-1.33-1.6-1.23m2.07.75.12.84 6.22-.76c.14-.02.25-.1.3-.23s.03-.27-.05-.38l-.28-.37c-.36-.48-.95-.73-1.53-.66l-3.22.39s-.49 1.03-1.56 1.16Zm-3.77 1.32-.12-.85-6.22.76a.39.39 0 0 0-.31.23c-.05.13-.03.27.05.38l.28.37c.36.48.94.73 1.53.66l3.22-.39s.49-1.03 1.56-1.16Z",
    className: "cls-1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M666.09 515.16c1.58 0 3.15-.24 4.65-.73a14.4 14.4 0 0 0 3.87-1.92 14.7 14.7 0 0 0 5.82-8.38c.72-2.81.6-5.77-.33-8.5-.46-1.37-1.12-2.68-1.98-3.89s-1.91-2.31-3.14-3.26a15.2 15.2 0 0 0-5.35-2.65c-2.5-.67-5.1-.68-7.55-.06-.02-1.57-.29-3.14-.79-4.64-.46-1.37-1.12-2.68-1.98-3.89s-1.91-2.31-3.14-3.26a15.1 15.1 0 0 0-5.35-2.65 14.97 14.97 0 0 0-12.4 2.14 14.7 14.7 0 0 0-5.82 8.38c-.64 2.48-.61 5.07.04 7.53-1.58 0-3.15.24-4.65.73a14.4 14.4 0 0 0-3.87 1.92 14.7 14.7 0 0 0-5.82 8.38c-.72 2.81-.6 5.77.33 8.5.46 1.37 1.12 2.68 1.98 3.89s1.91 2.31 3.14 3.26c1.64 1.27 3.47 2.15 5.35 2.65 2.5.67 5.1.68 7.55.06.02 1.58.29 3.14.79 4.64.46 1.37 1.12 2.68 1.98 3.89s1.91 2.31 3.14 3.26c1.64 1.27 3.47 2.15 5.35 2.65 2.83.76 5.8.67 8.53-.21a14.4 14.4 0 0 0 3.87-1.92c1.2-.84 2.29-1.87 3.23-3.08 1.25-1.62 2.11-3.43 2.59-5.3.64-2.48.61-5.07-.04-7.53Zm-29.21-.49c-1.5.56-3.11.8-4.71.69-1.07-.07-2.14-.3-3.16-.69-1.03-.39-2.02-.93-2.94-1.64a11.3 11.3 0 0 1-2.92-3.35 11.2 11.2 0 0 1-1.46-6.18c.06-1.07.27-2.13.65-3.14.37-1.02.91-2 1.61-2.91.93-1.21 2.06-2.17 3.32-2.86a11.1 11.1 0 0 1 6.7-1.32l9.21 7.1c.59 1.5.84 3.11.75 4.7-.01.17-.03.35-.04.52l-7 9.08Zm14.3-18.55c-1.5.56-3.1.8-4.71.69a9 9 0 0 1-.52-.05l-9.21-7.1c-.59-1.5-.84-3.11-.75-4.7.06-1.07.27-2.13.65-3.15.37-1.02.91-2 1.61-2.91.93-1.21 2.07-2.17 3.32-2.86 1.88-1.05 4.04-1.52 6.18-1.37 1.07.08 2.14.3 3.16.69 1.03.39 2.02.93 2.94 1.64a11.3 11.3 0 0 1 2.92 3.35 11.2 11.2 0 0 1 1.46 6.18c-.01.17-.03.35-.04.52l-7 9.08Zm10.67-6.26c1.5-.56 3.11-.8 4.71-.69 1.07.07 2.13.3 3.16.69s2.02.93 2.94 1.64a11.3 11.3 0 0 1 2.92 3.35 11.2 11.2 0 0 1 1.46 6.18 10.7 10.7 0 0 1-.65 3.15c-.37 1.02-.91 2-1.61 2.91-.93 1.21-2.07 2.17-3.32 2.87a11.1 11.1 0 0 1-6.7 1.32l-9.21-7.1c-.58-1.5-.84-3.1-.75-4.7.01-.17.02-.35.04-.52l7-9.08Zm-4.69 38.64a11.1 11.1 0 0 1-6.18 1.37c-1.07-.08-2.14-.3-3.17-.69s-2.02-.93-2.94-1.64a11.3 11.3 0 0 1-2.92-3.35 11.1 11.1 0 0 1-1.45-6.18c0-.17.02-.34.04-.52l7-9.08c1.5-.56 3.11-.8 4.71-.69.17.01.35.03.52.05l9.21 7.1c.59 1.5.84 3.11.75 4.7a10.7 10.7 0 0 1-.65 3.15c-.37 1.02-.91 2-1.61 2.9-.94 1.21-2.07 2.17-3.32 2.87Z",
    className: "cls-1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M653.86 488.36c-.49 1.2-1.3 2.25-2.33 3.02a7.1 7.1 0 0 1-3.54 1.39 7.24 7.24 0 0 1-3.76-.59 7.4 7.4 0 0 1-2.95-2.39l-.76.56a8.2 8.2 0 0 0 3.38 2.61c1.32.56 2.79.75 4.19.56 1.41-.19 2.75-.75 3.85-1.62s1.95-2.03 2.45-3.34l-.53-.21Zm-11.36-8.53a7.24 7.24 0 0 1 7.3-.81c1.17.52 2.2 1.36 2.95 2.39l.76-.56a8.2 8.2 0 0 0-3.38-2.61c-1.32-.56-2.79-.74-4.19-.56-1.4.19-2.75.75-3.85 1.62s-1.95 2.03-2.45 3.33l.53.21c.49-1.2 1.3-2.25 2.33-3.02Zm27.85 26.06a7.15 7.15 0 0 1-3.54 1.39 7.24 7.24 0 0 1-3.76-.59 7.4 7.4 0 0 1-2.95-2.39l-.76.56a8.2 8.2 0 0 0 3.38 2.61c1.32.56 2.79.75 4.19.56 1.41-.19 2.75-.75 3.85-1.62s1.95-2.03 2.45-3.34l-.53-.21c-.49 1.2-1.3 2.25-2.33 3.02Zm-11.36-8.53c.49-1.2 1.3-2.25 2.33-3.02a7.1 7.1 0 0 1 3.54-1.39 7.24 7.24 0 0 1 3.76.59c1.17.52 2.2 1.36 2.95 2.39l.76-.56a8.2 8.2 0 0 0-3.38-2.61c-1.32-.56-2.79-.75-4.19-.56-1.41.19-2.75.75-3.85 1.62s-1.95 2.03-2.45 3.34l.53.21Zm-.62 24.07a7.15 7.15 0 0 1-5.87 4.41 7.24 7.24 0 0 1-3.76-.59 7.4 7.4 0 0 1-2.95-2.39l-.76.56a8.2 8.2 0 0 0 3.38 2.61c1.32.56 2.79.75 4.19.56s2.75-.75 3.85-1.62 1.95-2.03 2.45-3.34l-.53-.21Zm-11.36-8.54a7.1 7.1 0 0 1 3.54-1.39 7.24 7.24 0 0 1 3.76.59c1.17.52 2.2 1.36 2.95 2.39l.76-.56a8.2 8.2 0 0 0-3.38-2.61c-1.32-.56-2.79-.75-4.19-.56-1.41.19-2.75.75-3.85 1.62s-1.95 2.03-2.45 3.34l.53.21c.49-1.2 1.3-2.25 2.33-3.02Zm-7.46-5.97c-.49 1.2-1.3 2.25-2.33 3.02a7.1 7.1 0 0 1-3.54 1.39 7.24 7.24 0 0 1-3.76-.59 7.4 7.4 0 0 1-2.95-2.39l-.76.56a8.2 8.2 0 0 0 3.38 2.61c1.32.56 2.79.75 4.19.56s2.75-.75 3.85-1.62 1.95-2.03 2.45-3.34l-.53-.21Zm-11.36-8.54a7.24 7.24 0 0 1 7.3-.81c1.17.52 2.2 1.36 2.95 2.39l.76-.56a8.25 8.25 0 0 0-3.38-2.61c-1.32-.56-2.79-.74-4.19-.56-1.4.19-2.75.75-3.85 1.62s-1.95 2.03-2.45 3.34l.53.21c.49-1.2 1.3-2.25 2.33-3.02",
    className: "cls-1"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "rotate(-49.61 331.287 54.785)scale(.95 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "rotate(-41.78 346.383 -52.048)scale(.95 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I"))), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "rotate(-35.41 382.753 -122.537)scale(.95 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "rotate(-27.02 436.18 -315.496)scale(.95 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Y"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "rotate(-21.49 479.77 -590.183)scale(.95 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "rotate(-16.14 576.239 -891.19)scale(.95 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "rotate(-8.49 877.1 -2237.778)scale(.95 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "matrix(.9498 -.0194 .02042 .9998 406 94.78)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "rotate(6.66 -558.974 4156.95)scale(.95 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "rotate(14.53 -122.41 2231.424)scale(.95 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "rotate(22.23 8.51 1638.424)scale(.95 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P"))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "rotate(29.94 75.952 1333.047)scale(.95 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "rotate(39.86 127.016 1105.208)scale(.95 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C"))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "rotate(50.73 163.313 946.728)scale(.95 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAerosoc);
export default __webpack_public_path__ + "static/media/AEROSOC.477e045efac0396e2382b9c4b30b6835.svg";
export { ForwardRef as ReactComponent };